// 延时
export const delay = (ms, callback) =>
    new Promise(resolve => {
        const timer = setTimeout(resolve, ms)

        callback?.(timer, resolve)
    })
